"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadingAsyncState = exports.loadedAsyncState = exports.errorAsyncState = exports.unauthorizedAsyncState = exports.unloadedAsyncState = exports.async = exports.getValue = exports.httpResult = void 0;
const widget_1 = require("../basics/widget");
const promise_1 = require("../primitives/promise");
const wait_1 = require("../primitives/wait");
const any_1 = require("./any");
exports.httpResult = {
    success: (value) => ({ kind: 'result', value: value, status: 200 }),
    unauthorized: () => ({ kind: 'unauthorized', status: 403 }),
    failed: () => ({ kind: 'failed', status: 500 }),
};
const getValue = (state) => state.kind === 'loaded' ? state.value : state.kind === 'loading' ? state.value : undefined;
exports.getValue = getValue;
const defaultMaxAttempts = 10;
const defaultInterval = 10;
/**
 * An asynchronous wrapper around the w widget.
 * Async is responsible for the dynamics, that is the execution of the
 * asynchronous process emboded by the supplied async state.
 * @param w The widget used to render&manage the loaded value
 * If you don't provide this is same as providing the empty widget `nothing()`
 * @param s0 The inner async state. It usually starts as unloaded.
 * Every time the inner asyncstate is set to loading by the client application, the asynchronous
 * state machine is started and the promise will fire. This means than in case of a promise
 * containing a remote call to an API, the networking communication runs at that point.
 *
 *@param options governing the rendering of temporary asynchronous states, caching, and retrying
 *
 */
const async = (s0, w, options) => {
    if (s0.kind === 'loading') {
        const p = s0.p;
        return (0, any_1.any)([
            options && options.loading ? options.loading(s0) : (0, widget_1.nothing)(),
            (0, promise_1.promise)(() => __awaiter(void 0, void 0, void 0, function* () {
                if (options &&
                    options.cache &&
                    !options.cache.forceFlush &&
                    s0.cache.kind === 'populated' &&
                    (Date.now() - s0.cache.loadedAt.valueOf()) / 1000 <= options.cache.expiryInSeconds) {
                    const cache = s0.cache;
                    return (s0) => (Object.assign(Object.assign({}, s0), { kind: 'loaded', retryCount: 0, value: cache.value, cache: cache }));
                }
                else {
                    const res = yield p({});
                    return (s0) => res.kind === 'result'
                        ? Object.assign(Object.assign({}, s0), { kind: 'loaded', retryCount: 0, value: res.value, cache: options && options.cache
                                ? { kind: 'populated', value: res.value, loadedAt: Date.now() }
                                : { kind: 'empty' } }) : res.kind === 'unauthorized'
                        ? Object.assign(Object.assign({}, s0), { kind: 'unauthorized', status: res.status, p: p }) : Object.assign(Object.assign({}, s0), { kind: 'failed', status: res.status, p: p });
                }
            }), {
                on_fail: () => 
                // NOTE: only connection-error is fed inside here, unless somebody intercepts it
                (s0) => s0.retryCount === undefined ||
                    s0.retryCount < ((options && options.retry && options.retry.maxAttempts) || defaultMaxAttempts)
                    ? Object.assign(Object.assign({}, s0), { kind: 'connection-error', retryCount: s0.retryCount ? s0.retryCount + 1 : 1, p: p }) : Object.assign(Object.assign({}, s0), { kind: 'failed', retryCount: 0, status: 500, p: p }),
                key: `async-promise-${(options === null || options === void 0 ? void 0 : options.key) || ''}`,
            })({}),
        ]);
    }
    else if (s0.kind === 'connection-error') {
        const p = s0.p;
        return (0, any_1.any)([
            options && options.connectionError !== undefined ? options.connectionError : (0, widget_1.nothing)(),
            s0.retryCount === undefined ||
                s0.retryCount < ((options && options.retry && options.retry.maxAttempts) || defaultMaxAttempts)
                ? (0, wait_1.wait)((options && options.retry && options.retry.interval) || defaultInterval, {
                    key: `async-wait-${(options === null || options === void 0 ? void 0 : options.key) || ''}`,
                })(() => (s0) => (Object.assign(Object.assign({}, s0), { kind: 'loading', p: p })))
                : (0, widget_1.nothing)(),
        ]);
    }
    else
        return s0.kind === 'loaded'
            ? w
                ? w(s0.value)
                : (0, widget_1.nothing)()
            : s0.kind === 'unauthorized'
                ? options && options.unauthorizedError
                    ? options.unauthorizedError
                    : (0, widget_1.nothing)()
                : s0.kind === 'failed'
                    ? options && options.otherError
                        ? options.otherError
                        : (0, widget_1.nothing)()
                    : options && options.unloaded
                        ? options.unloaded
                        : (0, widget_1.nothing)();
};
exports.async = async;
/**
 * A way to create a (initial) unloaded async state.
 * @param cache to start with
 */
const unloadedAsyncState = (cache) => ({
    kind: 'unloaded',
    type: 'async-widget',
    cache: cache ? Object.assign({}, cache) : { kind: 'empty' },
});
exports.unloadedAsyncState = unloadedAsyncState;
/**
 *
 * @deprecated Not much used explicitly. Just a helper function.
 */
const unauthorizedAsyncState = (status) => ({
    kind: 'unauthorized',
    type: 'async-widget',
    cache: { kind: 'empty' },
    status: status,
    p: () => new Promise((_) => { }),
});
exports.unauthorizedAsyncState = unauthorizedAsyncState;
/**
 * @deprecated Not much used explicitly. Just a helper function.
 */
const errorAsyncState = (status) => ({
    kind: 'failed',
    cache: { kind: 'empty' },
    type: 'async-widget',
    status: status,
    p: () => new Promise((_) => { }),
});
exports.errorAsyncState = errorAsyncState;
/**
 * A way to create an already-resolved async state
 *
 * @param v The resolved value injected
 */
const loadedAsyncState = (v) => ({
    kind: 'loaded',
    type: 'async-widget',
    cache: { kind: 'populated', value: v, loadedAt: Date.now() },
    value: v,
});
exports.loadedAsyncState = loadedAsyncState;
/**
 * A way to setup an asynchronous process, around an inputted lazy promise.
 * @param p The promise
 * @param old_value The previously loaded value (if available or relevant, used by the loading? widget)
 * @param cache
 */
const loadingAsyncState = (p, old_value, cache) => ({
    kind: 'loading',
    type: 'async-widget',
    value: old_value,
    cache: cache ? Object.assign({}, cache) : { kind: 'empty' },
    p: p,
});
exports.loadingAsyncState = loadingAsyncState;
